export default "/fonts/vendor/katex/dist/KaTeX_Caligraphic-Bold.woff?d757c535a2e5902f1325192d99e0c965";